import React from 'react';
import { StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';

import { Colors } from 'react-native-paper';
import { AppButton } from '../form';
import { pixelDimensions } from '../../config/utils';
import { appColors } from '../../assets/styles/global';

const CenterFab = ({ onPress, icon }) => (
  <AppButton primary disableDefaultColor rippleColor={appColors.primary} style={styles.fab} onPress={onPress} isCircle>
    <Icon name={icon} style={styles.icon} />
  </AppButton>
);

const styles = StyleSheet.create({
  fab: {
    position: 'absolute',
    bottom: pixelDimensions(4),
    alignSelf: 'center',
    justifyContent: 'center',
    elevation: 8,
    borderRadius: pixelDimensions(50),
    height: pixelDimensions(15),
    width: pixelDimensions(15),
    backgroundColor: Colors.white,
  },
  icon: {
    position: 'absolute',
    alignSelf: 'center',
    color: appColors.primary,
    fontSize: pixelDimensions(11),
  },
});

export default CenterFab;
